export const listaMateriaisEscritorio = [
  { id: 1, nome: 'Apagador Para Quadro Branco - Unidade' },
  { id: 2, nome: 'Caneta Esferográfica Preta - Unidade' },
  { id: 3, nome: 'Caneta Hidrocor - Estojo com 12 - Caixa' },
  { id: 4, nome: 'Caneta Marca Texto Amarela - Unidade' },
  { id: 5, nome: 'Caneta Marcador de Quadro Branco - azul - Unidade' },
  { id: 6, nome: 'Caneta Marcador de Quadro Branco - preta - Unidade' },
  {
    id: 7,
    nome: 'Caneta Marcador de Quadro Branco - vermelha - Unidade'
  },
  { id: 8, nome: 'Capa Encadernação Preta - Unidade' },
  { id: 9, nome: 'Capa Encadernação Transparente - Unidade' },
  { id: 10, nome: 'Cola Bastão - Unidade' },
  { id: 11, nome: 'Envelope - Papel Kraft - Unidade' },
  { id: 12, nome: 'Estilete  - Unidade' },
  { id: 13, nome: 'Extrator de Grampos  - Unidade' },
  { id: 14, nome: 'Grampeador Médio  - Unidade' },
  { id: 15, nome: 'Livro Ata  - Unidade' },
  { id: 16, nome: 'Pen Drive 16 GB - Unidade' },
  { id: 17, nome: 'Pen Drive 8 GB  - Unidade' },
  { id: 18, nome: 'Perfurador de Papel Pequeno - Unidade' },
  { id: 19, nome: 'Pilha Alcalina AA - Unidade' },
  { id: 20, nome: 'Pilha Alcalina AAA - Palito - Unidade' },
  { id: 21, nome: 'Porta Material - Unidade' },
  { id: 22, nome: 'Prancheta Portátil  - Unidade' },
  { id: 23, nome: 'Quadro Branco 60x90cm - Unidade' },
  { id: 24, nome: 'Tesoura  - Unidade' }
];
